export const SUSCRIPTION_ATTEMPT = "SUSCRIPTION_ATTEMPT";
export const SUSCRIPTION_SUCCESS = "SUSCRIPTION_SUCCESS";
export const SUSCRIPTION_FAILED = "SUSCRIPTION_FAILED";

export const PLAN_UPDATE_VALUE = "PLAN_UPDATE_VALUE";
export const PLAN_UPDATE_NEXT = "PLAN_UPDATE_NEXT";
export const LOGOUT = "LOGOUT";